<template>
  <div class="v-container">
    <div class="v-page-header">数据类型管理</div>
    <div class="v-header">
      <el-button @click="showAdd()" size="small" type="primary">新增类型</el-button>
      <div>
        <el-select v-loading="wxLoading" v-model="shop_id" placeholder="筛选小程序" style="width: 200px;margin-right: 5px" size="mini">
          <el-option v-for="item in wxList" :value="item.id" :key="item.id" :label="item.name"></el-option>
        </el-select>
        <el-input v-model="keyword" class="v-form-item" size="mini" placeholder="折线类型关键字" style="width: 200px"></el-input>
        <el-button class="v-ml-5" type="primary" size="mini" @click="getList(1)">搜索</el-button>
        <el-button size="mini" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="v-content" v-loading="loading">
      <el-table size="small" border :data="lists" height="100%">
        <el-table-column label="排序" width="100" prop="sort" />
        <el-table-column label="名称" prop="name"></el-table-column>
        <el-table-column label="内容" prop="value"></el-table-column>
        <el-table-column label="类型" prop="value">
          <template slot-scope="scope" width="100">
            <span v-if="scope.row.channel == 'pointsType'">折线类型</span>
            <span v-if="scope.row.channel == 'tzType'">宗教崇拜类型</span>
          </template>
        </el-table-column>
        <el-table-column label="所属小程序" prop="shopInfo.name" width="150"></el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button @click="showAddEdit(scope.row)" size="min" class="v-ml-5" type="warning">编辑</el-button>
            <el-popconfirm title="确认删除？" @onConfirm="doDelete(scope.row)">
              <el-button slot="reference" size="min" class="v-ml-5" type="danger" :loading="scope.row.deleteLoading">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <add-edit
      v-if="isShowAddEdit"
      :show.sync="isShowAddEdit"
      :row="row"
      @success="
        (page) => {
          getList(page);
        }
      "
    ></add-edit>
  </div>
</template>

<script>
import addEdit from './components/add-edit';

export default {
  components: { addEdit },

  data() {
    return {
      loading: false,
      lists: [],
      row: null,
      isShowAddEdit: false,
      wxLoading: false,
      shop_id: '',
      keyword: '',
      wxList: [],
    };
  },
  mounted() {
    this.getList();
    this.getWxList();
  },

  methods: {
    async getList() {
      this.loading = true;
      try {
        let res = await this.api.setting.lists({
          shop_id: this.shop_id,
          keyword: this.keyword,
        });
        this.lists = res.data;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    async getWxList() {
      this.wxLoading = true;
      try {
        let res = await this.api.shop.lists();
        this.wxList = res.data;
      } catch (e) {
        console.error(e);
      }
      this.wxLoading = false;
    },

    reset() {
      this.keyword = '';
      this.shop_id = '';
      this.getList(1);
    },

		showAdd(){
			this.row = null;
			this.isShowAddEdit = true;
    },

    showAddEdit(row) {
      this.row = row;
      this.isShowAddEdit = true;
    },

    //删除
    async doDelete(row) {
      this.$set(row, 'deleteLoading', true);
      try {
        await this.api.setting.delete({ id: row.id });
        this.$message.success('删除成功');
        this.getList();
      } catch (e) {
        console.error(e);
      }
      this.$set(row, 'deleteLoading', false);
    },
  },
};
</script>

<style scoped>
.v-header {
  display: flex;
  justify-content: space-between;
}
</style>
